import {PropsWithChildren, ReactNode, RefObject} from "react";
import classNames from "classnames";
import {AnimatePresence, motion} from "framer-motion";

import {homematchTinderReducedMotionTransition, homematchTinderSpringTransition} from "../../constants/homematch_tinder_motion";
import {HomematchTinderSentLeadMessage} from "../HomematchTinderSentLeadMessage";

import * as styles from "./HomematchTinderDetailsCard.module.css";

const contentFadeMotionProps = {
    animate: {opacity: 1},
    exit: {opacity: 0, transition: {duration: 0}},
    initial: {opacity: 0}
};

interface IProps extends PropsWithChildren {
    /** Action bar slot rendered under the card panel (apps wire their own thumbs logic). */
    actionBar: ReactNode;
    /** Keys the fading content — pass the displayed property id so card swaps animate. */
    contentKey?: number | string;
    contentRef: RefObject<HTMLDivElement | null>;
    isAdvancing: boolean;
    isSentLeadMessageVisible: boolean;
    sentLeadMessageDataTestId?: string;
    shouldReduceMotion: boolean;
    vendorName?: string;
}

export const HomematchTinderDetailsCard = (props: IProps) => {
    const {actionBar, children, contentKey, contentRef, isAdvancing, isSentLeadMessageVisible, sentLeadMessageDataTestId, shouldReduceMotion, vendorName} =
        props;

    return (
        <div className={styles.cardColumn}>
            <div className={styles.cardPanel}>
                <div className={styles.cardContent}>
                    <div className={styles.sentLeadMessageWrapper}>
                        <HomematchTinderSentLeadMessage
                            dataTestId={sentLeadMessageDataTestId}
                            isSentLeadMessageVisible={isSentLeadMessageVisible}
                            vendorName={vendorName}
                        />
                    </div>

                    <div className={classNames(styles.scrollArea, isAdvancing && styles.scrollAreaLocked)} ref={contentRef}>
                        <AnimatePresence initial={false} mode="sync">
                            {contentKey != null && (
                                <motion.div
                                    className={styles.content}
                                    key={contentKey}
                                    transition={shouldReduceMotion ? homematchTinderReducedMotionTransition : homematchTinderSpringTransition}
                                    {...contentFadeMotionProps}
                                >
                                    {children}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
            </div>

            <div className={styles.actionBarSlot}>{actionBar}</div>
        </div>
    );
};
import {PropsWithChildren, ReactNode, RefObject} from "react";
import classNames from "classnames";
import {AnimatePresence, motion} from "framer-motion";

import {homematchTinderReducedMotionTransition, homematchTinderSpringTransition} from "../../constants/homematch_tinder_motion";
import {HomematchTinderSentLeadMessage} from "../HomematchTinderSentLeadMessage";

import * as styles from "./HomematchTinderDetailsCard.module.css";

const contentFadeMotionProps = {
    animate: {opacity: 1},
    exit: {opacity: 0, transition: {duration: 0}},
    initial: {opacity: 0}
};

interface IProps extends PropsWithChildren {
    /** Action bar slot rendered under the card panel (apps wire their own thumbs logic). */
    actionBar: ReactNode;
    /** Keys the fading content — pass the displayed property id so card swaps animate. */
    contentKey?: number | string;
    contentRef: RefObject<HTMLDivElement | null>;
    isAdvancing: boolean;
    isSentLeadMessageVisible: boolean;
    sentLeadMessageDataTestId?: string;
    shouldReduceMotion: boolean;
    vendorName?: string;
}

export const HomematchTinderDetailsCard = (props: IProps) => {
    const {actionBar, children, contentKey, contentRef, isAdvancing, isSentLeadMessageVisible, sentLeadMessageDataTestId, shouldReduceMotion, vendorName} =
        props;

    return (
        <div className={styles.cardColumn}>
            <div className={styles.cardPanel}>
                <div className={styles.cardContent}>
                    <div className={styles.sentLeadMessageWrapper}>
                        <HomematchTinderSentLeadMessage
                            dataTestId={sentLeadMessageDataTestId}
                            isSentLeadMessageVisible={isSentLeadMessageVisible}
                            vendorName={vendorName}
                        />
                    </div>

                    <div className={classNames(styles.scrollArea, isAdvancing && styles.scrollAreaLocked)} ref={contentRef}>
                        <AnimatePresence initial={false} mode="sync">
                            {contentKey != null && (
                                <motion.div
                                    className={styles.content}
                                    key={contentKey}
                                    transition={shouldReduceMotion ? homematchTinderReducedMotionTransition : homematchTinderSpringTransition}
                                    {...contentFadeMotionProps}
                                >
                                    {children}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
            </div>

            <div className={styles.actionBarSlot}>{actionBar}</div>
        </div>
    );
};
